module.exports = __webpack_public_path__ + "img/Pro-11.d2243186.jpg";